if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      this.checkboxes = Array.from(this.querySelectorAll('input[type="checkbox"][required]'));
      this.checkoutButton = document.querySelector('#CheckOut');

      if (this.checkboxes.length > 0 && this.checkoutButton) {
        this.toggleCheckoutButton();

        this.checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', () => {
            this.toggleCheckoutButton();
          });
        });
      }
    }

    toggleCheckoutButton() {
      this.checkoutButton.disabled = !this.checkboxes.every(checkbox => checkbox.checked);
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}
